import { Box, InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { useEffect } from "react";
import MDInput from "components/MDInput";
import MDBox from "components/MDBox";
import useTranslation from "hooks/Translation";
import { getFromStorage } from "helpers";
import { STORAGE_KEYS } from "helpers";

const SearchBar = ({
  value,
  onChange,
  onCross,
  setDebouncedSearchTerm,
  searchTerm,
  placeholder,
}) => {
  const t = useTranslation();
  const getLang = getFromStorage(STORAGE_KEYS.language);
  useEffect(() => {
    const delay = 1000; // Debounce delay in milliseconds
    const timerId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, delay);

    return () => {
      clearTimeout(timerId); // Clear the timeout on cleanup
    };
  }, [searchTerm]);

  return (
    <MDBox className="search_bar">
      <MDInput
        value={value}
        onChange={onChange}
        hiddenLabel
        placeholder={placeholder ? placeholder : t.main.search}
        className="txt_inpt"
        fullWidth
        variant="outlined"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start" className="search_icon">
              <SearchIcon />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment
              position={getLang === "ar" ? "start" : "end"}
              className="cross_btn"
            >
              {value ? <ClearIcon onClick={onCross} /> : null}
            </InputAdornment>
          ),
        }}
      />
    </MDBox>
  );
};

export default SearchBar;
